export default {
    buscando: false,
    items: []
}